export const resources = {
  NoMetadata: '',
  NoDescription: ''
};
